import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const NonSupply = {
  Content: lazy(
    () =>
      import('components/direct-sales/non-supply/components/NonSupplyContent')
  ),
  Template: lazy(() => import('components/app/routes/NonRevampScreenTemplate'))
};

export default NonSupply;
